import React, { useState, useEffect } from "react";
import heart from "../ulits/images/heart.svg";
import { Link, useLocation } from "react-router-dom";
import { configs } from "../config";
import location from "../ulits/images/location-icon.svg";
import timesicon from "../ulits/images/times_icon.svg";
import tellicon from "../ulits/images/tell_icon.svg";
import emailicon from "../ulits/images/email_icon.svg";
import phoneicon from "../ulits/images/phone_icon.svg";
import closeicon from "../ulits/images/close_icon.svg";

function Footer(props) {
  const [config, setConfig] = useState({});
  const [showDisclosure, setShowDisclosure] = useState(false);

  useEffect(() => {
    setConfig(props?.configData);
  }, [props?.configData]);

  const year = new Date().getFullYear();

  const loc = useLocation();
  const hiddenFooter = ["/print"];

  if (hiddenFooter.includes(loc.pathname)) return null;


  return (
    <div className="site-footer">
      <div className="footer-top">
        {config && Object.keys(config).length > 0 && (
          <div className="container">
            <div className="footer-logo text-center">
              <Link to="/">
                <img
                  src={
                    config &&
                    config.Footer_logo &&
                    `${configs.localApiUrl}${config?.Footer_logo}`
                  }
                  alt="footer-logo"
                  style={{ width: "15%" }}
                />
              </Link>
            </div>
            <div className="row justify-content-center">
              <div className="col">
                <ul className="list-unstyled contents">
                  <li>
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${(config?.Address_line_1)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <img src={location} alt="location-icon" />
                      <p>{config?.Address_line_1}</p>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col">
                <ul className="list-unstyled contents">
                  <li>
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${(config?.Address_line_1)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <img src={location} alt="location-icon" />
                      <p>{config?.Address_line_1}</p>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col">
                <ul className="list-unstyled contents">
                  <li>
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${(config?.Address_line_3)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <img src={location} alt="location-icon" />
                      <p>{config?.Address_line_3}</p>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col opening-time">
                <ul className="list-unstyled contents">
                  <li>
                    <p>
                      <img
                        src={timesicon}
                        alt="location-icon"
                        className="timesicon"
                      />
                      {config && (
                        <span className="opening-hours-text">
                          {config?.Opening_hours}
                        </span>
                      )}
                    </p>
                  </li>
                </ul>
              </div>
              <div className="col contact">
                <ul className="list-unstyled">
                  <li>
                    <a href={`tel:${config && config.Free_phone}`}>
                      <img src={tellicon} alt="" className="tellicon" />{" "}
                      {config && config.Free_phone}
                    </a>
                  </li>
                  <li>
                    <a href={`tel:${config && config.Landline}`}>
                      <img
                        src={tellicon}
                        alt=""
                        className="tellicon d-none d-md-inline"
                      />{" "}
                      {config && config.Landline}
                    </a>
                  </li>
                  <li>
                    <a href={`tel:${config && config.Contact_Number}`}>
                      <img src={phoneicon} alt="" className="tellicon" />{" "}
                      {config && config.Contact_Number}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`mailto:${config?.Support_Email}`}
                      rel="noopener noreferrer"
                    >
                      <img src={emailicon} alt="" className="tellicon" />
                      {config?.Support_Email}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="view-full-disclosure">
              {!showDisclosure && (
                <p>
                  The Left Hand Drive Car Showroom Ltd is authorised and
                  regulated by the FCA (No. 911803). We are a credit broker, not
                  a lender, and may receive commission from lenders. Finance
                  subject to status.
                  {" "}
                  <span
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => setShowDisclosure(!showDisclosure)}
                  >
                    View full disclosure
                  </span>
                </p>
              )}

              {showDisclosure && (
                <div className="disclosure-details">
                  <h4>
                    Finance Disclosure
                    <img
                      src={closeicon}
                      alt=""
                      className="closeicon"
                      onClick={() => setShowDisclosure(!showDisclosure)}
                    />
                  </h4>
                  <p>
                    The Left Hand Drive Car Showroom Ltd is registered in
                    England and Wales under company number 09426099. Registered
                    address: 55 Cowley Road, Uxbridge, Middlesex, UB3 1LX,
                    United Kingdom.{" "}
                  </p>{" "}
                  <p>
                    We are authorised and regulated by the Financial Conduct
                    Authority under FCA number 911803.{" "}
                  </p>{" "}
                  <p>
                    We act as a credit broker, not a lender. We work with a
                    number of carefully selected credit providers who may be
                    able to offer you finance for your purchase. A written
                    quotation is available upon request.{" "}
                  </p>{" "}
                  <p>
                    Whichever lender we introduce you to, we will typically
                    receive a commission from them (either a fixed fee or a
                    fixed percentage of the amount you borrow). The commission
                    received may vary depending on the lender.{" "}
                  </p>{" "}
                  <p>
                    All finance is subject to status and income. Terms and
                    conditions apply. Applicants must be 18 years or over. We
                    are only able to offer finance products from our panel of
                    lenders.{" "}
                  </p>{" "}
                  <p>
                    The Left Hand Drive Car Showroom Ltd is also registered with
                    the Finance and Leasing Association in the UK.
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <ul className="list-inline">
                <li>
                  <Link to="/terms">Terms of use</Link>
                </li>
                <li>
                  <Link to="/privacy">Privacy</Link>
                </li>
              </ul>
              <p>
                &copy; {year} Copyright The Left Hand Drive Car Showroom
                Limited. All Rights Reserved.
              </p>
              <div className="loyalty-text">
                made with
                <em>
                  <img src={heart} alt="heart" />
                </em>
                by
                <Link to="https://softorigin.co.uk/" target="_blank">
                  {" "}
                  Soft Origin
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Footer;
